(function() {

  class Overlay {
    constructor() {
      document.addEventListener('overlay-open', () => {
        this.open();
      });
      document.addEventListener('overlay-instant-open', () => {
        this.open(undefined, true);
      });
      document.addEventListener('overlay-set-content', (data) => {
        this.setContent(data && data.detail && data.detail.html ? data.detail.html : data, data && data.detail && data.detail.callback ? data.detail.callback : undefined);
      });
      document.addEventListener('overlay-close', () => {
        this.close();
      });
      const overlay = document.querySelector('.u-overlay__close-button');
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.close();
        })
      }
      window.addEventListener('popstate', (event) => {
        console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));

        if(event.state && event.state.html) {
          this.setContent(event.state.html);
          this.open();
        } else {
          this.close();
        }
      });
      this.initGoToTopButton();
    }
    initGoToTopButton() {
      const goTotopButton = document.querySelector('.u-overlay__go-to-top-button');
      const overlayContent = document.querySelector('.u-overlay__content-wrapper');

      if (goTotopButton) {
        goTotopButton.addEventListener('click', () => {
          gsap.to(overlayContent, {duration: 1, scrollTo: 0 });
        });
      }

      const overlay = document.querySelector('.u-overlay');

      var isFixed = false;

      if (overlayContent) {
        overlayContent.addEventListener('scroll', () => {
          var st = overlayContent.scrollTop;
          var shouldBeFixed = st > overlayContent.offsetHeight;

          if(shouldBeFixed === isFixed) return;
          
          isFixed = shouldBeFixed;
          if(shouldBeFixed) {
            overlay.classList.add('u-overlay--fixed-go-to-top');
          } else {
            overlay.classList.remove('u-overlay--fixed-go-to-top');
          }
        }, false);
      }
    }
    open(callback, withoutAnimation) {

      const overlayWrapper = document.querySelector('.u-overlay__wrapper');
      if(overlayWrapper.classList.contains('is-open')) return;

      // animation
      const container = document.querySelector('.u-overlay');
      let tl = gsap.timeline({
        onComplete: () => {
          var event = new CustomEvent('overlay-content-ready');
          document.dispatchEvent(event);
        }
      });
  
      // add animations and labels to the timeline
      tl.addLabel("start")
        .fromTo(container, {translateY: '100%'}, {translateY: '0%', duration: withoutAnimation ? 0 : .4, ease: Linear.easeOut })
        .addLabel("end");
      overlayWrapper.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      if (callback) {
        callback();
      }
    }
    loading(state) {
      if(state) {
        document.querySelector('.u-overlay__wrapper').classList.add('is-loading');
      }
      else {
        document.querySelector('.u-overlay__wrapper').classList.remove('is-loading');
      }
    }
    setContent(html, callback) {
      document.querySelector('.u-overlay__content').innerHTML = html;
      if (typeof Hyphenopoly !== 'undefined') {
        Hyphenopoly.hyphenators.HTML.then((hyn) => {
          hyn(document.getElementsByClassName(".u-overlay")[0]);
        });
      }
      var event2 = new CustomEvent('generate-smooth-scroll-links', { detail: document.querySelector('.u-overlay__wrapper') });
      document.dispatchEvent(event2);
      var event3 = new CustomEvent('overlay-content-ready', { detail: document.querySelector('.u-overlay__wrapper') });
      document.dispatchEvent(event3);
      if (callback) {
        callback();
      }
    }
    close() {
      const container = document.querySelector('.u-overlay');
      let tl = gsap.timeline({
        onComplete: () => {
          document.querySelector('.u-overlay__wrapper').classList.remove('is-open');
          document.body.style.overflow = 'auto';
          document.querySelector('.u-header__popup-menu-wrapper').style.display = 'none';        }
      });
  
      // add animations and labels to the timeline
      tl.addLabel("start")
        .fromTo(container, {translateY: '0%'}, {translateY: '100%', duration: .4, ease: Linear.easeOut})
        .addLabel("end");
    }
  }

  const overlay = new Overlay();

  class OverlayLink {
    constructor(link) {
      if(!link || link.classList.contains('u-overlay-link--initialized')) return;
      link.classList.add('u-overlay-link--initialized');

      this.element = link;
      this.href = link.getAttribute('href');
      link.removeAttribute('href');
      link.classList.add('u-overlay-link');
      link.addEventListener('click', () => {
        this.openOverlay();
      });
    }

    openOverlay() {
      // open overlay
      overlay.loading(true);
      overlay.open();

      // load content
      fetch(this.href)
      .then(function(response) {
        return response.text()
      }).then(function(body) {
        overlay.setContent(body);

        // scroll overlay content to top 
        const contentWrapper = document.querySelector('.u-overlay__content-wrapper');
        contentWrapper.scrollTo(0,0);

        overlay.loading(false);
      })
    }
  }

  function initAll() {
    const uninitializedOverlayLinks = document.querySelectorAll('a[href][data-overlay="1"]');
    uninitializedOverlayLinks.forEach((link) => {
      new OverlayLink(link);
    })
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll();
  });

})();